import React from 'react';
import ButtonMUI from '../../../../shared/ButtonMUI';
import {ReactComponent as ProfileNotifications} from '../../../../assets/icons/profileNotifications.svg';
import './Head.scss';

const Head = ({title, button, handleNotificationRead, buttonLoadRead}) => {
  return (
    <div className='user-head'>
      <div className='user-head__title'>{title}</div>

      {button && (
        <ButtonMUI variant='outlined' color={'primary'} loading={buttonLoadRead} onClick={handleNotificationRead}>
          <ProfileNotifications />
          <span className='button-text'>{button}</span>
        </ButtonMUI>
      )}
    </div>
  );
};

export default Head;
